import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { projects } from '@/data/projects'
import { ProjectCard } from '@/components/ProjectCard'

export function FeaturedProjects() {
  const featured = projects.filter((p) => p.featured).slice(0, 3)
  if (featured.length === 0) return null

  return (
    <section className="container border-t border-border/60 py-16">
      <div className="mb-8 flex items-end justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Featured Projects</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Optimization, ML, and the seams between them.
          </p>
        </div>
        <Link
          to="/projects"
          className="inline-flex items-center gap-1 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          All projects
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {featured.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </section>
  )
}
